<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'UserList' }" class="nav-link">Użytkownicy</router-link>/Nowy użytkownik</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <UserForm :handle-submit="create" :values="item" :errors="violations"></UserForm>
    </div>

  </b-container>
</template>

<script>
  import UserForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('user/create');

  export default {
    components: {
      UserForm
    },
    data: function() {
      return {
        item: {}
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('user/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'UserUpdate', params: { id: created.id} });
        }
      }
    },
    created() {
      this.$store.dispatch('user/create/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?7d0254a0